import { render, staticRenderFns } from "./CodeSnippet.vue?vue&type=template&id=2199fcf2&scoped=true"
import script from "./CodeSnippet.vue?vue&type=script&lang=js"
export * from "./CodeSnippet.vue?vue&type=script&lang=js"
import style0 from "./CodeSnippet.vue?vue&type=style&index=0&id=2199fcf2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2199fcf2",
  null
  
)

export default component.exports